<template>
    <div>
        <AppPopover id="user-menu" parent-class="right-0">
            <template #button="{ open }">
                <button class="text-gray-500 cursor-pointer" @click="handleClick">
                    <Icon name="tabler:user" size="24px" />
                    <Icon
                        size="16px"
                        v-if="useDevice().isDesktop"
                        :name="open ? 'tabler:chevron-up' : 'tabler:chevron-down'"
                    />
                </button>
            </template>

            <template #content="{ close }">
                <div ref="hiddenElementID" class="hidden" @click="close()"></div>
                <AppUserMenuItems @select-item="close" />
            </template>
        </AppPopover>
    </div>
</template>

<script setup lang="ts">
const { isDesktop } = useDevice();
const handleClick = (event: Event) => {
    if (isDesktop) event.preventDefault();
};

const showMobileMenu = useMobileMenuOpen();
const hiddenElementID = ref<null | HTMLDivElement>(null);
watch(showMobileMenu, () => {
    hiddenElementID.value?.click();
});
</script>
